var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.Button,
    {
      staticClass:
        "w-100 text-start btn-sm p-1 ps-2 d-flex align-items-center visible-on-hover",
      attrs: { "active-class": "btn-primary", "active-value": _setup.isActive },
      nativeOn: {
        click: function ($event) {
          $event.preventDefault()
          return _setup.onClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex-fill overflow-hidden text-nowrap small" },
        [
          _c(_setup.UserTrackingAvatar, {
            attrs: { "item-id": _vm.item.id, "table-name": _setup.tableName },
          }),
          _vm._v("\n\n        " + _vm._s(_vm.item.title) + "\n\n        "),
          _vm.item.contentType && (_setup.sortAlpha || _setup.navSearch)
            ? _c(
                "span",
                {
                  staticClass: "ms-1 text-dark bg-secondary-subtle rounded p-1",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.item.contentType) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.mode === "text/x-scss"
            ? _c("span", { staticClass: "ms-1 badge text-primary-emphasis" }, [
                _vm._v("SCSS"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.mode === "text/x-less"
            ? _c("span", { staticClass: "ms-1 badge text-primary-emphasis" }, [
                _vm._v("LESS"),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.ThemesEditorEditBtn, { attrs: { item: _vm.item } }),
      _vm._v(" "),
      _c(_setup.ThemesEditorUsage, {
        staticClass: "ms-1",
        attrs: { id: _vm.item.id },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }